import { render } from "./ServicePaymentFormView.vue?vue&type=template&id=4757890b&scoped=true&ts=true"
import script from "./ServicePaymentFormView.vue?vue&type=script&lang=ts"
export * from "./ServicePaymentFormView.vue?vue&type=script&lang=ts"

import "./ServicePaymentFormView.vue?vue&type=style&index=0&id=4757890b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4757890b"]])

export default __exports__